module.exports = __webpack_public_path__ + "static/media/Motorola Moto 360 Men Silver + Black Open.255021e7.png";